import * as go from 'gojs';
import { getImageMobileScreen } from 'unitData/Mobile/Screen/getImageMobileScreen';
import { alignPorts } from 'unitData/Mobile/Screen/mobileScreenData';
import {
  getImageBinding,
  getMobileInputPort,
  getMobileOutputPort,
  makeNode,
  mobileUnitDefaultOptions,
} from '../../utils';
import type { MobileUnitBaseNodeData } from 'gojs/types';

const MobileScreenTemplate = makeNode(
  getImageBinding('', (node: MobileUnitBaseNodeData) =>
    getImageMobileScreen(node.configuration.configKey, node.model),
  ),
  [
    getMobileOutputPort(0, alignPorts),
    getMobileOutputPort(1, alignPorts),
    getMobileOutputPort(2, alignPorts),
    getMobileOutputPort(3, alignPorts),
    getMobileOutputPort(4, alignPorts),
    getMobileOutputPort(5, alignPorts),
    getMobileInputPort((node) => {
      if (node.model === 'UF373' || node.model === 'UF473') {
        return node.mirrored
          ? new go.Spot(1 - 5 / 12, 0)
          : new go.Spot(5 / 12, 0);
      } else {
        return node.mirrored
          ? new go.Spot(1 - 3 / 12, 0)
          : new go.Spot(3 / 12, 0);
      }
    }),
  ],
  { ...mobileUnitDefaultOptions },
);

export default MobileScreenTemplate;
